import { render, staticRenderFns } from "./BannerShortcutFormLink.vue?vue&type=template&id=1fa8d0f3&"
import script from "./BannerShortcutFormLink.vue?vue&type=script&lang=js&"
export * from "./BannerShortcutFormLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports